// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"5f3832a3","161":"f1ba2dc2","228":"4b3b5385","393":"21a59c81","447":"fb08f9d0","573":"1ee028a2","774":"ec84d60d","867":"98993275","891":"3154ac70","904":"e0883d61"}[chunkId] + ".chunk.js";
};